import { defineComponent as s, ref as l } from "vue";
import p from "./index4.js";
import { useBaseApplicationTranslation as h } from "../../../shared/libraries/local-translations/index.js";
const S = s({
  name: "Search",
  components: {
    SearchInput: p
  },
  props: {
    suggestions: {
      type: Array,
      required: !0
    },
    searchSubmitHandler: {
      type: Object,
      required: !0
    },
    hasSearchButton: {
      type: Boolean,
      default: !0
    },
    hasSearchIcon: {
      type: Boolean,
      default: !1
    },
    algoliaExpVar: {
      type: String,
      required: !0
    },
    placeholder: {
      type: String
    },
    config: {
      type: Object,
      required: !0
    }
  },
  setup(n) {
    let e = !1;
    const t = l(""), o = (r) => {
      t.value = r;
    }, { t: u } = h(), c = () => {
      a();
    }, a = (r) => {
      if (e)
        return;
      e = !0;
      const i = t.value.trim();
      n.searchSubmitHandler.handle(i, r), e = !1;
    };
    return {
      searchQuery: t,
      t: u,
      handleSearchSubmitButtonClick: a,
      handleSearchGoButtonClick: c,
      updateQuery: o
    };
  }
});
export {
  S as default
};
//# sourceMappingURL=index2.js.map
